let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("03WNz")).then(() => parcelRequire('lQYwp'));